import classNames from 'classnames'
import { CuratedPropertiesPageQuery } from 'gql/graphql'
import { HomeIcon } from 'components/icons'
import PropertyCard from 'components/property/PropertyCard'
import useOutsideClick from 'data/hooks/useOutsideClick'
import { useScreenWidth } from 'data/hooks/useScreenWidth'

type PropTypes = {
  lng: number
  lat: number
  property?: CuratedPropertiesPageQuery['properties']['data'][number]
}

const MapMarker = ({ property }: PropTypes) => {
  const { isMobile } = useScreenWidth()

  const {
    isActive: isPropertyCardOpen,
    setIsActive: setIsPropertyCardOpen,
    ref,
  } = useOutsideClick(false)

  // TODO: Bring back Property Fragments
  // const propertyData = useFragment(PropertyCard_PropertyFragment, property)

  return (
    <div
      ref={ref}
      className={classNames('absolute -translate-x-1/2 -translate-y-1/2 text-primary text-36', {
        'cursor-pointer': !!property,
        'z-50': isPropertyCardOpen,
      })}
      onClick={() => setIsPropertyCardOpen(true)}
    >
      <HomeIcon />
      {!!property && isPropertyCardOpen && (
        <div className={classNames('min-w-[240px] sm:min-w-[320px] p-[15px] bg-white rounded-10 absolute', {
          'left-30 top-30': !isMobile,
          '-left-[100px] sm:-left-[140px] top-40': isMobile,
        })}>
          <PropertyCard property={property} target="_blank" />
        </div>
      )}
    </div>
  )
}

export default MapMarker
